import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#111"
      fillRule="evenodd"
      d="M5.8 12.394a.7.7 0 0 1 .01-.99l3.054-3.002L5.81 5.399a.7.7 0 0 1 .982-.998l3.46 3.402a.84.84 0 0 1 0 1.198L6.79 12.402a.7.7 0 0 1-.99-.008Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
